/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * As input parameter, either id or locode or name can be used. Notice that id and locode is unique whereas name may not be unique. The Locode is not defined for all ports.
 * @export
 * @interface Port
 */
export interface Port {
    /**
     * 
     * @type {number}
     * @memberof Port
     */
    id?: number;
    /**
     * 5 alphanumeric characters: 2 for country and 3 for location. Notice that the Locode is not defined for all ports.
     * @type {string}
     * @memberof Port
     */
    locode?: string;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    country?: string;
}

/**
 * Check if a given object implements the Port interface.
 */
export function instanceOfPort(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortFromJSON(json: any): Port {
    return PortFromJSONTyped(json, false);
}

export function PortFromJSONTyped(json: any, ignoreDiscriminator: boolean): Port {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'locode': !exists(json, 'locode') ? undefined : json['locode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'country': !exists(json, 'country') ? undefined : json['country'],
    };
}

export function PortToJSON(value?: Port | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'locode': value.locode,
        'name': value.name,
        'country': value.country,
    };
}

